// Shamelessly stolen from https://web.dev/lazy-loading-images/#images-inline-intersection-observer
document.addEventListener("DOMContentLoaded", function() {
	const lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

	if ("IntersectionObserver" in window) {
		const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					const lazyImage = entry.target;
					lazyImage.src = lazyImage.dataset.src;
					lazyImage.classList.remove("lazy");
					lazyImageObserver.unobserve(lazyImage);
				}
			});
		}, {
			// Load items earlier to lessen chance of seeing blank/unloaded images
			rootMargin: "0px 0px 500px 0px"
		});

		lazyImages.forEach(function(lazyImage) {
			lazyImageObserver.observe(lazyImage);
		});
	} else {
		// Possibly fall back to event handlers here
	}
});